'use client';

import { useTranslations } from 'next-intl';
import { Link } from '~/components/Link';
import { trackEvent } from '~/utils';
import styles from './BpiLinkBanner.module.css';
import type { BpiLinkBannerFilters, BpiLinkBannerProps } from './BpiLinkBanner.types';

const BPI_PATH = '/blueprint-index';

// param names match the ones BPI reads, so CMS-configured filters survive the hop
export const buildBpiHref = ({ searchFilter, featureFilter, durationFilter }: BpiLinkBannerFilters = {}) => {
  const params = new URLSearchParams();

  if (searchFilter) params.set('destination', searchFilter);
  if (featureFilter) params.set('themes', featureFilter);
  if (durationFilter) params.set('duration', durationFilter);

  const queryString = params.toString();

  return queryString ? `${BPI_PATH}?${queryString}` : BPI_PATH;
};

const BpiLinkBanner = ({
  label,
  ctaLabel,
  href,
  tracking,
  searchFilter,
  featureFilter,
  durationFilter
}: BpiLinkBannerProps) => {
  const t = useTranslations('content');

  const handleCtaClick = () => {
    trackEvent(tracking.name, {
      event_category: tracking.category ?? 'click',
      event_label: tracking.label ?? tracking.name
    });
  };

  return (
    <div className={styles.banner} data-test-id="BpiLinkBanner">
      <p className={styles.label}>{label ?? t('trips_something_else')}</p>
      <Link
        href={href ?? buildBpiHref({ searchFilter, featureFilter, durationFilter })}
        asButton="secondary"
        size="responsive"
        target="_self"
        noWrap
        onClick={handleCtaClick}
        dataTestId="BpiLinkBannerCta"
      >
        {ctaLabel ?? t('trips_all')}
      </Link>
    </div>
  );
};

export { BpiLinkBanner };
